import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles/Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = document.getElementById('newsletterForm');
    const email = form.email.value;

    // Here you can add your newsletter signup logic
    console.log('Subscribed email:', email);

    // Clear the form
    form.reset();

    // Optional: Show success message
    alert('Thanks for subscribing!');
  }

  return (
    <footer id="footer">
      <div className="footer-top">
        <Container>
          <Row>
            <Col lg={3} md={6} className="footer-info">
              <h3>Harusi Online..</h3>

              <p style={{ color: 'black' }}>
                3rd Floor, Room No 417 New Safari Hotel Business Centre, Arusha, Tanzania<br></br>
                <strong>Phone:</strong> <a href="tel:+255747636516">+255 747 636 516</a><br />
                <strong>Email:</strong> <a href="mailto:harusidotonline@gmail.com">harusidotonline@gmail.com</a><br />
              </p>


              <div className="social-links mt-3">
                <Link to="#" className="btn btn-outline-primary me-2">
                  <i className="bi bi-twitter"></i>
                </Link>
                <Link to="https://www.facebook.com/harusionlinetz/" className="btn btn-outline-primary me-2" target="_blank" >
                  <i className="bi bi-facebook"></i>
                </Link>
                <Link to="https://www.instagram.com/harusionline/" className="btn btn-outline-primary me-2" target="_blank"  >
                  <i className="bi bi-instagram"></i>
                </Link>
                <a href="https://wa.me/255747636516" className="btn btn-outline-primary me-2" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp"></i>
                </a>
              </div>



            </Col>
            <Col lg={2} md={6} className="footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li><i className="bi bi-chevron-right"></i> <Link to="/Home">Home</Link></li>
                <li><i className="bi bi-chevron-right"></i> <Link to="/about">About us</Link></li>
                <li><i className="bi bi-chevron-right"></i> <Link to="/Gharama">Gharama</Link></li>
                <li><i className="bi bi-chevron-right"></i> <Link to="/e_card">E-Card</Link></li>
                <li><i className="bi bi-chevron-right"></i> <Link to="/terms">Terms & Conditions</Link></li>
                <li><i className="bi bi-chevron-right"></i> <Link to="/privacy">Privacy Policy</Link></li>
                <li><i className="bi bi-chevron-right"></i> <Link to="/login">Event Admin</Link></li>
                <li><i className="bi bi-chevron-right"></i> <Link to="/awards">Awards</Link></li>
              </ul>
            </Col>
            <Col lg={3} md={6} className="footer-links">
              <h4>Our Services</h4>
              <ul>
                <li><i className="bi bi-chevron-right"></i> <Link to="/Events">All Events</Link></li>
                <li><i className="bi bi-chevron-right"></i> <Link to="/login">Tuma Taarifa</Link></li>
                <li><i className="bx bi-chevron-right"></i> <Link to="/login">Kadi za Kidigitali</Link></li>
                <li><i className="bx bi-chevron-right"></i> <Link to="/login">Tuma Mialiko</Link></li>
                <li><i className="bx bi-chevron-right"></i> <Link to="/login">Ripori ya Fedha</Link></li>
                <li>
                  <i className="bx bi-chevron-right"></i>
                  <Link to="/login">Login As MtoaHuduma</Link>
                </li>

              </ul>
            </Col>
            <Col lg={4} md={6} className="footer-newsletter">
              <h4>Our Newsletter</h4>

              <p>Join our community of engaged couples and receive valuable insights directly to your inbox.</p>

              <form id="newsletterForm" onSubmit={handleSubmit}>
                <input type="email" name="email" required />
                <input type="submit" value="Subscribe" />
              </form>


              <h5 className="mt-4">Download Our App</h5>
              <div className="d-flex">
                <a href="https://apps.apple.com/us/app/harusi-online/id1629222934" className="me-3" target="_blank" rel="noopener noreferrer">
                  <img src={require('../images/apple.png')} alt="Apple App Store" style={{ width: '124px', height: '39px' }} />
                </a>
                <a href="https://play.google.com/store/apps/details?id=harusi.online.mobile&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                  <img src={require('../images/android.png')} alt="Google Play Store" style={{ width: '124px', height: '39px' }} />
                </a>
              </div>
            </Col>

          </Row>
        </Container>
      </div>
      <Container>
        <div className="copyright">

          <p>© {currentYear} Harusi online Tanzania. All rights reserved. | <Link to="/terms" style={{ color: 'black' }}>Terms</Link> | <Link to="/privacy" style={{ color: 'black' }}>Privacy Policy</Link> | Developed by <Link to="https://www.sj.co.tz/" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}>SJ Software & Consultancy</Link></p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;